import { useQuery } from "@apollo/client";
import { FC } from "react";
import { GET_ME, GET_USERS } from "../../query/UserQueries";
import Error from "../Error/QueryError";
import Loading from "../Loading";
import { H1, H2 } from "../Title";
import { SpendingChart } from "./SpendingChart";
import { SimpleGameAnalytics } from "./analytics/SimpleGameAnalytics";
import { StyledChartContainer, StyledSection } from "./common/styles";
import { PurchaseData, UserData } from "./common/types";
import { EnhancedUsersChart } from "./users/EnhancedUsersChart";

import { ADMIN_ID, ADMIN_USERNAME } from "../../constants/admin";

export { ADMIN_ID, ADMIN_USERNAME };

export const Charts: FC = () => {
  const {
    loading: loadingUsers,
    error: errorUsers,
    data: dataUsers,
  } = useQuery(GET_USERS);
  const { loading: loadingMe, error: errorMe, data: dataMe } = useQuery(GET_ME);

  const isLoading = loadingUsers || loadingMe;
  const isError = errorUsers || errorMe;

  if (isLoading) return <Loading />;
  if (isError) return <Error error={errorUsers || errorMe} />;

  const currentUser = dataMe?.me;
  if (currentUser?.username !== ADMIN_USERNAME) {
    return (
      <StyledChartContainer>
        <StyledSection>
          <h1>Accès non autorisé</h1>
          <p>Vous n'avez pas la permission de voir cette page.</p>
        </StyledSection>
      </StyledChartContainer>
    );
  }

  // Extraire tous les achats depuis les données utilisateurs
  const allPurchases: PurchaseData[] = [];
  const allUsers: UserData[] = dataUsers?.users || [];

  allUsers.forEach((user) => {
    if (user.purchases) {
      user.purchases.forEach((purchase) => {
        allPurchases.push({
          ...purchase,
          userId: user.id,
        });
      });
    }
  });

  const filteredPurchases = allPurchases.filter((p) => p.userId !== ADMIN_ID);

  return (
    <StyledChartContainer>
      <H1>Tableau de Bord - Admin</H1>

      <H2>Analyse des Utilisateurs</H2>
      <EnhancedUsersChart users={allUsers} />

      <H2>Analyse des Dépenses</H2>
      <SpendingChart purchases={filteredPurchases} users={allUsers} />

      <H2>Analytics du Jeu</H2>
      <SimpleGameAnalytics />
    </StyledChartContainer>
  );
};

export default Charts;
